import { Message } from '../../types/agent.dictionary'

export type ChatState = {
  isStreaming: boolean
  messages: Message[]
  pendingAiResponse: boolean
  streamingAiResponse: boolean
  sessionId: string | null
  pendingRequestActionMessage: string | null
  previousUserMessage: string | null
  agentId: string | null
  voiceEnabled: boolean
  isRecording: boolean
}

export const initialState: ChatState = {
  isStreaming: false,
  messages: [],
  pendingAiResponse: false,
  streamingAiResponse: false,
  sessionId: null,
  pendingRequestActionMessage: null,
  previousUserMessage: null,
  agentId: null,
  voiceEnabled: false,
  isRecording: false,
}
